<template>
  <div>
    <div>
      <el-input v-if="search" v-model="form.searchValue" :placeholder="placeholder" clearable />
    </div>
    
    <div class="el-tree-main">
      <div class="tree_title">
        <i class="el-icon-menu"></i>
        <span>部门列表</span>
      </div>
      <el-tree
        ref="tree"
        icon-class="el-icon-arrow-right"
        :current-node-key="checkedKeys"
        :data="treeList"
        node-key="id"
        :props="defaultProps"
        :highlight-current="highlightCurrent"
        :default-expand-all="true"
        :expand-on-click-node="expandOnClickNode"
        @node-click="handleNodeClick"
        :filter-node-method="filterNode"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <span class="custom-tree-icons" v-if="node.level <= 2 && showOperat">
            <i
              class="el-icon-edit"
              v-dynHasPermi:[authIdentity]="'edit'"
              @click="() => handleEditNode(node, data)"
            ></i>
            <i
              class="el-icon-delete"
              v-dynHasPermi:[authIdentity]="'remove'"
              @click="() => handleRemoveNode(node, data)"
            ></i>
          </span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: 'treeNav',
  props: {
    checkedKeys: {
      type: Number,
      default: 0,
    },

    treeList: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '请输入',
    },
    defaultRxpandAll: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: true,
    },
    sidebarFlag: {
      type: Boolean,
      default: true,
    },
    highlightCurrent: {
      type: Boolean,
      default: false,
    },
    isArr: {
      type: Boolean,
      default: false,
    },
    expandOnClickNode: {
      type: Boolean,
      default: true,
    },
    filterKey: {
      type: String,
      default: 'label',
    },
    showOperat: {
      type: Boolean,
      default: false,
    },
    authIdentity: {
      type: String,
      required: false,
      validator(val) {
        if (val && new RegExp(/^([a-zA-Z0-9_-]+)\s*:\s*([^\s,]+)$/).test(val)) {
          return true
        } else {
          console.warn('权限标识示例：', 'system:test')
          console.error('权限标识错误：', val)
          return false
        }
      },
    },
  },
  components: {},
  data() {
    return {
      form: {
        id: '',
        searchValue: '',
      },
      defaultProps: {
        children: 'children',
        label: 'deptName',
      },
    }
  },
  watch: {
    'form.searchValue': function (val) {
      this.$refs.tree.filter(val)
    },
  },
  methods: {
    handleQuery() {
      this.$emit('on-search', this.form)
    },

    handleNodeClick(data) {
      console.log(data, 'data-------')
      if (this.isArr && data.children && data.children.length > 0) {
        let ids = []
        let arr = this.getString(
          this.flatten(data.children, 'children'),
          'id',
          'arr'
        )
        ids = [data.id, ...arr]
        this.form.ids = ids
      }

      this.form.id = data.id
      // }
      this.$emit('on-tree', this.form, data)
      this.$emit('on-search', data)
    },

    filterNode(value, data) {
      if (!value) return true
      return data[this.filterKey].indexOf(value) !== -1
    },
    handleEditNode(node, data) {
      this.$emit('on-edit', { node, data })
    },
    handleRemoveNode(node, data) {
      this.$emit('on-remove', { node, data })
    },
    setCurrentKey(key) {
      this.$refs['tree'].setCurrentKey(key)
    },
  },
}
</script>

<style lang='less' scoped>
@import '~@/assets/variables.less';
.wrap {
  position: relative;
  width: 100%;
  .hamburger {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
  }
}

.hamburger.is-active {
  transform: rotate(180deg);
}
.el-tree-main{
  background: #fff;
  border: 1px solid rgba(192, 196, 204, 0.6);
  border-radius: @table-radius-size;
  margin-top: 10px;
}
.tree_title{
  padding: 0 5px;
  line-height: 40px;
  font-size: 14px;
  border-bottom: 1px solid rgba(192, 196, 204, 0.6);
  span{
    margin-left: 5px;
  }
}
.el-tree {
  height: calc(100vh - 30vh);
  background-color: transparent;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 5px;

  ::v-deep {
    .el-tree-node__content {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      .el-icon-arrow-right {
        color: #656d95;
        font-size: 14px;
        font-weight: bold;
      }
      // 最低子级下拉图标
      .is-leaf {
        color: transparent;
      }

      .custom-tree-node {
        flex: 1;
        color: #3c4254;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 5px;
        .custom-tree-icons {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          i {
            width: 14px;
            height: 14px;
            display: inline-block;
          }
        }

        .custom-tree-icons i + i {
          margin-left: 3px;
        }
      }
    }

    // children
    // .el-tree-node__children .custom-tree-node {
    //   color: #757b8c;
    // }
    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
      background-color: #b6d9fc;
    }
    // .el-tree-node.is-current > .el-tree-node__content {
    //   background-color: @hover-color;
    // }
    .el-tree-node__content:hover {
      background: @hover-color;
    }
  }
}
</style>
